import { Rate } from '../redux/reducers/currency'
import { fetchRequest } from '../services/http.service'

export const GET_RATES_URL = '/exchangerate'

export const getRatesRequest = (currency: string) => fetchRequest.get<Rate[]>(GET_RATES_URL + `/${currency}`)
